<template>
<div>
    <v-row>
        <v-col cols='12' md='12' class='text-center'>
            <v-card class='mx-auto ml-3 mr-3'>
                <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class='headline'>Make a general enquiry</v-list-item-title>
                    <v-list-item-subtitle>Please Make Sure To Add An Email Or Day Mobile Number For Our Team To Be Able To Get Intouch. Thank You For Choosing EquatorSun.</v-list-item-subtitle>
                </v-list-item-content>
                </v-list-item>
                <v-card-text>
               <v-card shaped class='pa-md-4 mx-lg-auto' elevation='3'>
                <v-form v-model='valid' @submit.prevent='SendInquiry' class='ml-3 mr-3'>
                    <v-row>
                        <v-col cols='12' md='6'>
                            <v-text-field v-model='Firstname' :rules='nameRules' :counter='10' label='First name' required></v-text-field>
                        </v-col>
                        <v-col cols='12' md='6'>
                            <v-text-field v-model='Lastname' :rules='LastnameRules' :counter='10' label='Last name' required></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols='12' md='6'>
                            <v-text-field v-model='Email' :rules='emailRules' label='E-mail' required></v-text-field>
                        </v-col>
                        <v-col cols='12' md='6'>
                            <v-text-field v-model='PhoneNumber' :counter='15' label='Day Time Phone' required></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols='12' md='6'>
                            <v-select v-model='Inquiry' :items='InquiryType' label='Inquiry Type'></v-select>
                        </v-col>
                        <v-col cols='12' md='6'>
                            <v-textarea
                                outlined
                                name='input-7-1'
                                v-model='Remarks'
                                label='Remarks'
                                hint='Any Other Details You Might Want Us To Know'
                            ></v-textarea>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols='12'>
                            <v-spacer></v-spacer>
                            <v-btn text class='blue darken-4' type='submit' dark>SEND</v-btn>
                        </v-col>
                    </v-row>

                </v-form>
               </v-card>
                </v-card-text>

                <v-row v-if='sendingEmail' class='fill-height' align-content='center' justify='center'>
                    <v-col class='subtitle-1 text-center' cols='12'>
                        Sending...
                    </v-col>
                    <v-col cols='6'>
                        <v-progress-linear color='yellow accent-4' indeterminate rounded height='6'></v-progress-linear>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>

    <v-bottom-sheet v-model='formError'>
        <v-sheet class='text-center red darken-3 mb-4' height='100px' dark>
          <v-btn class='mt-6' flat color='blue darken-3 mb-4' dark @click='formError = !formError'>close</v-btn>
          <div dark>{{formErrorMessage}}</div>
        </v-sheet>
      </v-bottom-sheet>

</div>
</template>
<script>
export default {
  data () {
    return {
      InquiryType: ['GENERAL QUESTION', 'TECHNICAL QUESTION', 'FEED BACK'],
      Firstname: null,
      Lastname: null,
      Email: null,
      PhoneNumber: null,
      Inquiry: null,
      Remarks: null,
      valid: false,
      formError: false,
      formErrorMessage: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => v.length <= 10 || 'Name must be less than 10 characters'
      ],
      LastnameRules: [
        v => !!v || 'Last Name is required',
        v => v.length <= 10 || 'Name must be less than 10 characters'
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ]
    }
  },
  computed: {
    sendingEmail () {
      return this.$store.getters.getLoading
    }
  },
  methods: {
    SendInquiry () {
      if (this.Firstname == null) {
        this.formError = true
        this.formErrorMessage = 'Please Enter Your First Name'
      } else if (this.Lastname == null) {
        this.formError = true
        this.formErrorMessage = 'Please Enter Your Last Name'
      } else if (this.Inquiry == null) {
        this.formError = true
        this.formErrorMessage = 'Please Select Inquiry Type'
      } else if (this.Remarks == null) {
        this.formError = true
        this.formErrorMessage = 'Please Add A Message'
      } else {
        this.formError = false
        this.formErrorMessage = ''
        const Message = {
          Firstname: this.Firstname,
          Lastname: this.Lastname,
          Email: this.Email,
          PhoneNumber: this.PhoneNumber,
          Inquiry: this.Inquiry,
          Remarks: this.Remarks
        }

        this.$store.dispatch('sendInquiry', Message)
      }
    }
  }
}
</script>
